import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook,useSelector,useDispatch } from "react-redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage
// import storageSession from "redux-persist/lib/storage/session"; // sessionStorage
import authReducer from "./slices/auth/auth.slice"
import orgReducer from "./slices/org/org.slice"
import { getOrgSlugFromUrl } from "utils/getOrgSlugFromUrl";


// const orgSlug = getOrgSlugFromUrl()
const authPersistConfig = {
  //  key: `auth_${orgSlug}`,
   key: `auth`,

  storage, // switch to storageSession if needed
  whitelist: ["accessToken", "user", "roles", "isAuthenticated",'pendingVerification'],
};



const persistedAuthReducer = persistReducer(
  authPersistConfig,
  authReducer
);

const reducer = {
    auth:persistedAuthReducer,
    organization:orgReducer
}
export const store = configureStore({
    reducer,
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // required for redux-persist
    }),
})

export const persistor = persistStore(store);
export type RootState = {
  auth: ReturnType<typeof authReducer> & {
    _persist: { rehydrated: boolean; version: number };
  };
  organization: ReturnType<typeof orgReducer>;
};
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector : TypedUseSelectorHook<RootState> = useSelector